






































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListWorkDescriptions } from '@/components/config'

// services
import { WorkDescriptionService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// models
import { WorkDescriptionForm, WorkDescriptionModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditWorkDescription from './modalCreateEdit.vue'

const newItem: WorkDescriptionForm = {
  name: '',
  price: 0,
  is_active: true,
  is_group_piecework: false
}

@Component({
  name: 'WorkDescriptionsIndex',
  components: {
    PageHeader,
    TableListWorkDescriptions,
    ModalCreateEditWorkDescription
  }
})
export default class WorkDescriptionsIndex extends Vue {
  showModal = false
  workDescription: WorkDescriptionForm = newItem
  title = 'Descripción de trabajo'
  actionForm = 'save'
  idItemEdit: number|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Descripción de Trabajo',
      active: true
    }
  ]

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.workDescription = newItem
    this.showModal = true
  }

  editItem (item: WorkDescriptionModel) {
    this.workDescription = {
      name: item.name,
      price: item.price,
      is_active: item.is_active,
      is_group_piecework: item.is_group_piecework
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: WorkDescriptionModel) {
    const msg = `Seguro que desea eliminar la Descripción de Trabajo: ${item.name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await WorkDescriptionService.delete(item.id)
      alerts.success()
      this.tableList.getWorkDescriptionsWithPagination()
      loading('hide')
    }
  }

  async changeStatus (info: {id: number; status: boolean}) {
    loading('show')
    try {
      await WorkDescriptionService.changeStatus(info.id, info.status)
      alerts.success()
      this.tableList.getWorkDescriptionsWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  get tableList (): Vue & { getWorkDescriptionsWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getWorkDescriptionsWithPagination: () => void }
  }

  get itemInit (): WorkDescriptionForm {
      return newItem
  }
}
